export const GradientBackground = () => {
  return (
    <div
      className="fixed inset-0 -z-10 overflow-hidden bg-slate-50"
      aria-hidden="true"
      data-testid="animated-gradient-background"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-50 via-sky-50/60 to-white" />
      <div
        className="gradient-blob absolute -top-1/4 -left-1/4 h-[70vh] w-[70vh] rounded-full bg-sky-200/40 blur-3xl"
      />
      <div
        className="gradient-blob-slow absolute top-1/3 -right-1/4 h-[60vh] w-[60vh] rounded-full bg-slate-300/30 blur-3xl"
      />
      <div
        className="gradient-blob absolute bottom-0 left-1/4 h-[55vh] w-[55vh] rounded-full bg-blue-100/50 blur-3xl"
        style={{ animationDelay: "-8s" }}
      />
      <div
        className="absolute inset-0 opacity-[0.015]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
    </div>
  );
};
